export default "__VITE_ASSET__CEf0rn7c__"